import { createStore } from 'satcheljs';
import { LinkedInStoreObject } from './schema/LinkedInStoreObject';

export let linkedInStore = createStore<LinkedInStoreObject>('linkedInStore', {
    status: null,
});
